import type { EmployeeQueryParams, EntraDirectoryQueryParams } from '../api/people.api'

/**
 * Typed cache keys for the people feature (Contractors + Employees + EntraDirectory).
 *
 * Per ADR-0012: query keys are typed constants, never inline string arrays.
 * Prefix shape preserves compatibility with the previous inline keys
 * (`['contractors']`, `['employees', queryParams]`, `['entra-directory', queryParams]`,
 * `['sync-job', jobId]`, `['entra-directory-licenses']`).
 *
 * Note: `person-types` is owned by `@/features/master-data` (see `masterDataKeys.personTypes`).
 * Consumers that need person types should call `usePersonTypes()` from that feature.
 */
export const peopleKeys = {
	contractors: {
		all: ['contractors'] as const,
		list: () => ['contractors'] as const,
	},
	employees: {
		all: ['employees'] as const,
		list: (params: EmployeeQueryParams) => ['employees', params] as const,
		contractorsRef: () => ['contractors'] as const,
	},
	entraDirectory: {
		all: ['entra-directory'] as const,
		list: (params: EntraDirectoryQueryParams) => ['entra-directory', params] as const,
	},
	entraSyncJob: (jobId: string | null) => ['sync-job', jobId] as const,
	entraLicenses: () => ['entra-directory-licenses'] as const,
}
